'use strict';

import React from 'react/addons';
import { values } from 'underscore';
import AnalyticsSources from '../constants/AnalyticsSources';
import OverlayStore from '../stores/OverlayStore';
import ContextMenuTypes from '../constants/ContextMenuTypes';
import createStoreMixin from '../mixins/createStoreMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';
import UserProfileContextMenu from '../contextMenus/UserProfileContextMenu';
import StampShareContextMenu from '../contextMenus/StampShareContextMenu';
import ZineShareContextMenu from '../contextMenus/ZineShareContextMenu';
import UserShareContextMenu from '../contextMenus/UserShareContextMenu';
import StampMoreContextMenu from '../contextMenus/StampMoreContextMenu';
import ZineMoreContextMenu from '../contextMenus/ZineMoreContextMenu';
import CreateStampOrZineContextMenu from '../contextMenus/CreateStampOrZineContextMenu';
import ZineColorPickerContextMenu from '../contextMenus/ZineColorPickerContextMenu';
import ZineStatusPickerContextMenu from '../contextMenus/ZineStatusPickerContextMenu';
import EditorMoreContextMenu from '../contextMenus/EditorMoreContextMenu';
import TimeoutTransitionGroup from '../utils/TimeoutTransitionGroup';
import StampStatusPickerContextMenu from '../contextMenus/StampStatusPickerContextMenu';

const ContextMenuHost = React.createClass({
  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

  getStateFromStores() {
    return {
      contextMenu: OverlayStore.getContextMenu()
    };
  },

  childContextTypes: {
    source: React.PropTypes.oneOf(values(AnalyticsSources))
  },

  getChildContext() {
    return {
      source: this.state.contextMenu && this.state.contextMenu.source
    };
  },

  render() {
    var menu = this.renderMenu(this.state.contextMenu);

    return (
      <TimeoutTransitionGroup transitionName='ContextMenu'
                              enterTimeout={200}
                              leaveTimeout={200}>
        {menu}
      </TimeoutTransitionGroup>
    );
  },

  renderMenu(contextMenu) {
    if (!contextMenu) {
      return null;
    }

    switch (contextMenu.id) {
    case ContextMenuTypes.STAMP_SHARE:
      return (<StampShareContextMenu key='stampShare'
                                     stampId={contextMenu.stampId}
                                     anchorRect={contextMenu.anchorRect}
                                     services={contextMenu.services} />);

    case ContextMenuTypes.ZINE_SHARE:
      return (<ZineShareContextMenu key='zineShare'
                                    zineSlug={contextMenu.zineSlug}
                                    anchorRect={contextMenu.anchorRect} />);

    case ContextMenuTypes.USER_SHARE:
      return (<UserShareContextMenu key='userShare'
                                    userId={contextMenu.userId}
                                    anchorRect={contextMenu.anchorRect} />);

    case ContextMenuTypes.STAMP_MORE:
      return (<StampMoreContextMenu key='stampMore'
                                    stampId={contextMenu.stampId}
                                    showEdit={contextMenu.showEdit}
                                    shareServices={contextMenu.shareServices}
                                    anchorRect={contextMenu.anchorRect} />);

    case ContextMenuTypes.ZINE_MORE:
      return (<ZineMoreContextMenu key='zineMore'
                                   zineSlug={contextMenu.zineSlug}
                                   isMeCurator={contextMenu.isMeCurator}
                                   anchorRect={contextMenu.anchorRect} />);

    case ContextMenuTypes.USER_PROFILE:
      return (<UserProfileContextMenu key='user'
                                      userId={contextMenu.userId}
                                      anchorRect={contextMenu.anchorRect} />);

    case ContextMenuTypes.CREATE:
      return (<CreateStampOrZineContextMenu key='createStampOrZine'
                                            anchorRect={contextMenu.anchorRect} />);

    case ContextMenuTypes.ZINE_COLOR_PICKER:
      return (<ZineColorPickerContextMenu key='zineColorPicker'
                                          anchorRect={contextMenu.anchorRect}
                                          previousColor={contextMenu.previousColor} />);

    case ContextMenuTypes.ZINE_STATUS_PICKER:
      return <ZineStatusPickerContextMenu key='zineColorPicker'
                                          anchorRect={contextMenu.anchorRect} />;

    case ContextMenuTypes.EDITOR_MORE:
      return (<EditorMoreContextMenu key='editorMore'
                                     anchorRect={contextMenu.anchorRect}
                                     stampSegment={contextMenu.stampSegment} />);

    case ContextMenuTypes.STAMP_STATUS_PICKER:
      return (<StampStatusPickerContextMenu key='stampColorPicker'
                                            anchorRect={contextMenu.anchorRect} />);
    }
  }
});

export default ContextMenuHost;



/** WEBPACK FOOTER **
 ** ./hosts/ContextMenuHost.jsx
 **/